import PropTypes from 'prop-types'
import {
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

const ExitConfirmationDialog = ({
  header,
  body,
  buttonClose,
  buttonConfirm,
  isOpen,
  onClose,
  onConfirmExit,
}) => {
  const {t} = useTranslation('invitePayers')

  const headerText = header || t('exitConfirmation.title')
  const bodyText = body || t('exitConfirmation.message')
  const buttonContinueText =
    buttonClose || t('exitConfirmation.buttons.continueSetup')
  const buttonExitText =
    buttonConfirm || t('exitConfirmation.buttons.exitAnyway')

  return (
    <AlertDialog isOpen={isOpen} onClose={onClose}>
      <AlertDialogOverlay>
        <AlertDialogContent data-testid="exit-confirmation-dialog">
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {headerText}
          </AlertDialogHeader>
          <AlertDialogBody>{bodyText}</AlertDialogBody>
          <AlertDialogFooter>
            <Button onClick={onClose}>{buttonContinueText}</Button>
            <Button colorScheme="red" onClick={onConfirmExit} ml={3}>
              {buttonExitText}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}

ExitConfirmationDialog.defaultProps = {
  header: '',
  body: '',
  buttonClose: '',
  buttonConfirm: '',
}

ExitConfirmationDialog.propTypes = {
  header: PropTypes.string,
  body: PropTypes.string,
  buttonClose: PropTypes.string,
  buttonConfirm: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirmExit: PropTypes.func.isRequired,
}

export default ExitConfirmationDialog
